import React from 'react';
import styled from 'styled-components';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

const Container = styled.div`
  margin: auto;
`
const SelectStyled = styled(Select)`
  width: 150px;
  background: #eee;
  padding: 5px;
`

const DragHandle = ({
  items,
  ...other
}) => {

  return (
    <Container>
      <SelectStyled {...other}>
        {items.map((item, index) => {
          return <MenuItem key={`menu-item-${index}`} value={item.value}>{item.label}</MenuItem>
        })}
      </SelectStyled>
    </Container>
  )
}

export default DragHandle;
